






























































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import CetakResumeSvc, { NAMA_DOKUMEN_RESUME } from "@/services/CetakResume";
import PreviewPDFModal from "@/components/PreviewPDFModal.vue";
import {
  AlasanCetakUlang,
  JenisResumeCetak,
  KodeAlasanCetakUlang,
  PeruntukanResume,
  StatusCetakResume
} from "@/types/resume_cetak";

@Component({
  components: { PreviewPDFModal }
})
export default class ResumeCetakMenu extends Vue {
  @Prop({
    type: String,
    required: true,
    validator: (nilai: string) => ["ranap"].includes(nilai)
  })
  readonly jenis!: JenisResumeCetak;

  @Prop({ type: [Number, String], required: true })
  readonly resumeId!: number | string;

  menu = false;
  memuat = false;
  mencetak = false;
  konfirmasiTerbuka = false;
  cetakUlangTerbuka = false;
  riwayatTerbuka = false;
  dipilih: PeruntukanResume | null = null;
  status: StatusCetakResume | null = null;
  alasan: KodeAlasanCetakUlang | null = null;
  catatan = "";
  pratinjauTerbuka = false;
  memuatPratinjau = false;
  pdfPratinjau: string | null = null;

  kolomRiwayat = [
    { text: "Waktu cetak", value: "waktu", width: 140 },
    { text: "Lembar untuk", value: "label" },
    { text: "Jenis", value: "jenis", width: 150 },
    { text: "Alasan & catatan", value: "alasan" },
    { text: "Dicetak oleh", value: "oleh" },
    { text: "IP", value: "ip", width: 110 }
  ];

  get namaDokumen(): string {
    return NAMA_DOKUMEN_RESUME[this.jenis];
  }

  get daftarPeruntukan(): PeruntukanResume[] {
    return this.status ? this.status.peruntukan : [];
  }

  get pilihanAlasan(): AlasanCetakUlang[] {
    return this.status ? this.status.pilihan_alasan : [];
  }

  get labelSemuaPeruntukan(): string {
    return this.daftarPeruntukan.map(item => item.label).join(", ");
  }

  get keterangan(): string {
    if (!this.status) {
      return "Memuat status cetak...";
    }

    if (!this.status.ditandatangani) {
      return "Resume belum ditandatangani DPJP. Lembar resmi baru dapat dicetak setelah ditandatangani.";
    }

    return `Sisa ${this.status.sisa} dari ${this.status.batas} lembar. Lembar yang rusak atau hilang dapat dicetak ulang dengan alasan.`;
  }

  get kekuranganCetakUlang(): string {
    if (!this.alasan) {
      return "Pilih alasan cetak ulang.";
    }

    if (this.catatan.trim().length < 5) {
      return "Isi catatan minimal 5 karakter.";
    }

    return "";
  }

  get riwayat() {
    if (!this.status) {
      return [];
    }

    return this.status.riwayat.map(baris => ({
      id: baris.id,
      waktu: this.formatWaktu(baris.waktu),
      label: baris.label,
      jenis:
        baris.jenis === "cetak_ulang"
          ? `Cetak ulang ke-${baris.cetak_ulang_ke}`
          : `Cetak asli ke-${baris.cetakan_ke}`,
      alasan: baris.alasan
        ? `${baris.alasan}${baris.catatan ? ` — ${baris.catatan}` : ""}`
        : "-",
      oleh: baris.oleh || "-",
      ip: baris.ip || "-"
    }));
  }

  @Watch("menu")
  onMenu(terbuka: boolean) {
    if (terbuka) {
      this.muatStatus();
    }
  }

  @Watch("pratinjauTerbuka")
  onPratinjauTerbuka(terbuka: boolean) {
    if (!terbuka) {
      this.lepasPratinjau();
    }
  }

  beforeDestroy() {
    this.lepasPratinjau();
  }

  @Watch("resumeId")
  onResumeId() {
    this.status = null;
  }

  formatWaktu(waktu: string | null): string {
    return waktu ? moment(waktu).format("DD-MM-YYYY HH:mm") : "-";
  }

  keteranganLembar(item: PeruntukanResume): string {
    if (item.cetak) {
      const asli = `Dicetak ${this.formatWaktu(item.cetak.waktu)} oleh ${item
        .cetak.oleh || "-"} (cetakan ke-${item.cetak.cetakan_ke})`;
      const terakhir = item.cetak_ulang_terakhir;

      if (!item.jumlah_cetak_ulang || !terakhir) {
        return asli;
      }

      return `${asli} · dicetak ulang ${
        item.jumlah_cetak_ulang
      }× (terakhir ${this.formatWaktu(terakhir.waktu)}, ${terakhir.alasan ||
        "-"})`;
    }

    if (this.status && !this.status.ditandatangani) {
      return "Menunggu tanda tangan DPJP";
    }

    return "Belum dicetak";
  }

  bisaDicetak(): boolean {
    return !!this.status && this.status.ditandatangani && !this.mencetak;
  }

  async muatStatus() {
    const resumeId = this.resumeId;
    this.memuat = true;

    try {
      const status = await CetakResumeSvc.statusCetak(this.jenis, resumeId);

      if (resumeId === this.resumeId) {
        this.status = status;
        this.$nextTick(this.posisikanUlangMenu);
      }
    } catch (e) {
      this.status = null;
    } finally {
      this.memuat = false;
    }
  }

  async lihat() {
    if (this.memuatPratinjau) {
      return;
    }

    this.memuatPratinjau = true;
    this.pratinjauTerbuka = false;
    this.lepasPratinjau();

    try {
      this.pdfPratinjau = await CetakResumeSvc.pratinjau(
        this.jenis,
        this.resumeId
      );
      this.menu = false;
      this.pratinjauTerbuka = true;
    } catch (e) {
      return;
    } finally {
      this.memuatPratinjau = false;
    }
  }

  lepasPratinjau() {
    if (this.pdfPratinjau) {
      URL.revokeObjectURL(this.pdfPratinjau);
      this.pdfPratinjau = null;
    }
  }

  posisikanUlangMenu() {
    const menu = this.$refs.menu as Vue & { onResize?: () => void };

    if (menu && menu.onResize) {
      menu.onResize();
    }
  }

  pilih(item: PeruntukanResume) {
    this.dipilih = item;

    if (item.cetak) {
      this.alasan = null;
      this.catatan = "";
      this.cetakUlangTerbuka = true;
    } else {
      this.konfirmasiTerbuka = true;
    }
  }

  async cetak() {
    if (!this.dipilih || this.mencetak) {
      return;
    }

    const cetakUlang = this.dipilih.cetak
      ? { alasan: this.alasan, catatan: this.catatan.trim() }
      : null;

    if (cetakUlang && this.kekuranganCetakUlang) {
      return;
    }

    this.mencetak = true;

    try {
      await CetakResumeSvc.cetak(
        this.jenis,
        this.resumeId,
        this.dipilih.kode,
        cetakUlang
      );
      this.$emit("dicetak", this.dipilih.kode);
      this.konfirmasiTerbuka = false;
      this.cetakUlangTerbuka = false;
    } catch (e) {
      return;
    } finally {
      this.mencetak = false;
      this.muatStatus();
    }
  }
}
